import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/joy/Button";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import Stack from "@mui/joy/Stack";
import { Avatar, Box, Option, Select } from "@mui/joy";
import { connect, useDispatch, useSelector } from "react-redux";
import EmptyList from "../Shared/EmptyList";
import {
  add_category,
  apply_feature_category,
  delete_category,
  edit_category,
  get_category,
  update_category_settings,
} from "../reduxData/user/userAction";

const Category = ({ categoriesList, totalCategories }) => {
  const [open, setOpen] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteCategoryID, setDeleteCategoryID] = useState(null);
  const [categoryName, setCategoryName] = useState("");
  const [categoryImage, setCategoryImage] = useState(null);
  const [editId, setEditId] = useState(null);
  const [editObj, setEditObj] = useState(null);
  const [errors, setErrors] = useState({ name: "", image: "" });
  const dispatch = useDispatch();
  const imageRef = useRef();
  const [imagePreview, setImagePreview] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      await get_category(dispatch, localStorage.getItem("token"), 1, 100);
    } catch (error) {
      console.error("Error fetching category data:", error);
    }
  };

  const setEditCategory = (edit) => {
    setCategoryName(edit?.name);
    setCategoryImage(`${edit?.category_image}`);
    setEditId(edit?._id);
    setEditObj(edit);
    setOpen(true);
  };

  const handleImage = (e) => {
    e.preventDefault();
    imageRef.current.click();
  };

  const handleChange = (e, label) => {
    if (label === "name") {
      setCategoryName(e.target.value.trim());
      setErrors({
        ...errors,
        [label]: !e.target.value ? "Name is required" : "",
      });
    }
    if (label === "image") {
      setCategoryImage(e.target.files[0]);
      setImagePreview(URL.createObjectURL(e.target.files[0]));
      setErrors({ ...errors, [label]: "" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({
      name: !categoryName ? "Name is required" : null,
      image: !categoryImage ? "Image is required" : null,
    });

    if (!categoryName || !categoryImage) return;

    const formData = new FormData();
    formData.append("name", categoryName);

    if (editId) {
      if (editObj?.category_image !== categoryImage) {
        formData.append("image", categoryImage);
      }
      const data = await edit_category(
        formData,
        localStorage.getItem("token"),
        editObj?._id,
        dispatch,
      );
      if (data?.data?.status) {
        fetchData();
        setOpen(false);
        setImagePreview("");
      }
    } else {
      formData.append("image", categoryImage);
      const data = await add_category(
        formData,
        localStorage.getItem("token"),
        dispatch,
      );
      if (data?.data?.status) {
        fetchData();
        setOpen(false);
        setImagePreview("");
      }
    }
  };

  const deleteCategory = async (id) => {
    try {
      const data = await delete_category(
        id,
        localStorage.getItem("token"),
        dispatch,
      );
      if (data?.data?.status) {
        fetchData();
        setDeleteModal(false);
      }
    } catch (error) {
      console.error("Error deleting category:", error);
    }
  };

  const handleFeatured = async (item) => {
    const categorydata = {
      name: item?.name.trim(),
      image: item?.category_image,
      is_feature: !item?.is_feature,
    };
    await apply_feature_category(
      categorydata,
      localStorage.getItem("token"),
      item?._id,
      dispatch,
    );
    fetchData();
  };

  const handleLocked = async (item) => {
    const payload = {
      categoryId: item._id,
      is_locked: !item.is_locked,
    };
    await update_category_settings(
      payload,
      localStorage.getItem("token"),
      dispatch,
    );
    fetchData();
  };

  const handleHighlightOverride = async (item, newValue) => {
    const payload = {
      categoryId: item._id,
      highlight_override: newValue,
    };
    await update_category_settings(
      payload,
      localStorage.getItem("token"),
      dispatch,
    );
    fetchData();
  };

  return (
    <div className="container">
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="fw-600 col-md-6">Auctions Category</h3>
        {((user?.role === "staff" && user?.permission?.p_categories > 1) ||
          user?.role !== "staff") && (
          <button
            className="btn common-button"
            onClick={() => {
              setEditId(null);
              setCategoryName("");
              setCategoryImage(null);
              setImagePreview(null);
              setOpen(true);
            }}
          >
            + Add New category
          </button>
        )}
      </div>

      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
          setErrors({ name: "", image: "" });
          setImagePreview(null);
        }}
      >
        <ModalDialog>
          <DialogTitle>{editId ? "Edit" : "Create new"} category</DialogTitle>
          <DialogContent>
            Fill in the information of the Category.
          </DialogContent>
          <form onSubmit={handleSubmit}>
            <Stack spacing={2}>
              <FormControl>
                <FormLabel>Category Name</FormLabel>
                <Input
                  autoFocus
                  placeholder="Enter name"
                  value={categoryName}
                  onChange={(e) => handleChange(e, "name")}
                />
                {errors?.name && (
                  <div className="error_msg">{errors?.name}</div>
                )}
              </FormControl>

              <FormControl>
                <FormLabel>Category Image</FormLabel>
                <div className="d-flex">
                  {imagePreview ? (
                    <div className="mt-3">
                      <img
                        src={imagePreview}
                        alt="category"
                        className="preview-image"
                      />
                    </div>
                  ) : categoryImage ? (
                    <div className="mt-3">
                      <img
                        src={categoryImage}
                        alt="category"
                        className="preview-image"
                      />
                    </div>
                  ) : (
                    <div className="mt-3"></div>
                  )}

                  <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={(e) => handleChange(e, "image")}
                    className="align-items-center d-none"
                    ref={imageRef}
                  />
                  <button
                    type="button"
                    onClick={handleImage}
                    className="btn btn-warning ms-4 mt-3"
                    style={{ height: "40px" }}
                  >
                    {editId ? "Edit" : "Upload"} Image
                  </button>
                </div>
                {errors?.image && (
                  <div className="error_msg">{errors?.image}</div>
                )}
              </FormControl>
              <button type="submit" className="btn common-button">
                Submit
              </button>
            </Stack>
          </form>
        </ModalDialog>
      </Modal>

      <Modal open={deleteModal} onClose={() => setDeleteModal(false)}>
        <ModalDialog>
          <DialogTitle>Delete Category</DialogTitle>
          <DialogContent>
            Are you sure you want to delete category?
          </DialogContent>
          <Box mt={2} display="flex" gap={2}>
            <Button variant="outlined" onClick={() => setDeleteModal(false)}>
              Cancel
            </Button>
            <Button
              color="danger"
              onClick={() => deleteCategory(deleteCategoryID)}
            >
              Delete
            </Button>
          </Box>
        </ModalDialog>
      </Modal>

      <div className="table-responsive mt-3">
        <table className="table table-hover user-management-table auction-category-list">
          <thead className="border-gray">
            <tr>
              <th>Thumbnail</th>
              <th>Category Name</th>
              <th>Featured</th>
              <th>Locked</th>
              <th>Highlight Text</th>
              {((user?.role === "staff" &&
                user?.permission?.p_categories > 1) ||
                user?.role !== "staff") && <th>Action</th>}
            </tr>
          </thead>
          <tbody>
            {totalCategories > 0 ? (
              categoriesList.map((item, index) => (
                <tr key={item._id || index}>
                  <td>
                    <Avatar
                      src={`${item.category_image}`}
                      alt={`Item Thumbnail`}
                    />
                  </td>
                  <td className="fw-500">{item.name}</td>

                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        role="switch"
                        disabled={
                          user?.role === "staff" &&
                          user?.permission?.p_categories < 2
                        }
                        checked={item?.is_feature || false}
                        onChange={() => handleFeatured(item)}
                      />
                    </div>
                  </td>

                  <td>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input cursor-pointer"
                        type="checkbox"
                        role="switch"
                        disabled={
                          user?.role === "staff" &&
                          user?.permission?.p_categories < 2
                        }
                        checked={item?.is_locked || false}
                        onChange={() => handleLocked(item)}
                      />
                    </div>
                  </td>

                  <td>
                    <Select
                      value={item?.highlight_override || "auto"}
                      onChange={(e, newValue) =>
                        handleHighlightOverride(item, newValue)
                      }
                      disabled={
                        user?.role === "staff" &&
                        user?.permission?.p_categories < 2
                      }
                      size="sm"
                      sx={{ minWidth: 160 }}
                    >
                      <Option value="auto">Auto Select</Option>
                      <Option value="newly_posted">New Listings</Option>
                      <Option value="active_auctions">Active Auctions</Option>
                      <Option value="total_sales">Total Sales Volume</Option>
                    </Select>
                  </td>

                  {((user?.role === "staff" &&
                    user?.permission?.p_categories > 1) ||
                    user?.role !== "staff") && (
                    <td>
                      <i
                        className="cursor-pointer mx-2 far fa-edit edit text-primary"
                        onClick={() => setEditCategory(item)}
                      />
                      {((user?.role === "staff" &&
                        user?.permission?.p_categories > 2) ||
                        user?.role !== "staff") && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          viewBox="0 0 16 16"
                          className="cursor-pointer delete-icon bi bi-trash3-fill text-danger"
                          onClick={() => {
                            setDeleteModal(true);
                            setDeleteCategoryID(item?._id);
                          }}
                        >
                          <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                        </svg>
                      )}
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">
                  <EmptyList name="Category" />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  categoriesList: state.user.categoriesList,
  totalCategories: state.user.totalCategories,
});

export default connect(mapStateToProps)(Category);
